import { WpWordsType } from '@app/modules/search/types';
import { DateTimeStr } from '@mi-front/core';
import { useState } from 'react';
import { WordInput } from './WordInput';
import { useEditor } from './useEditor';

interface WordEditorProps {
  words?: WpWordsType[];
  fragmentId: string;
  time: DateTimeStr;
  onReplaceAll: (new_word: string, old_word: string) => void;
}

export function WordEditor({ words, fragmentId, time, onReplaceAll }: WordEditorProps) {
  const [bufferWords, setBufferWords] = useState<WpWordsType[]>(words || []);
  const { handleUpdateWords } = useEditor();

  if (!bufferWords) {
    return null;
  }

  const handleSave = async (word: string, idx: number) => {
    const newWords = bufferWords.map((w, i) => (i === idx ? { ...w, word, confidence: 1 } : w));
    setBufferWords(newWords);
    const wpWords = newWords[idx];
    await handleUpdateWords(fragmentId, time, [wpWords]);
  };

  const handleReplaceAll = async (new_word: string, old_word: string) => {
    onReplaceAll(new_word, old_word);
  };

  return (
    <div>
      {bufferWords?.map(({ word }, idx) => (
        <WordInput
          key={`${word}-${idx}`}
          idx={idx}
          word={word}
          onSave={(word) => handleSave(word, idx)}
          onReplaceAll={handleReplaceAll}
        />
      ))}
    </div>
  );
}
